var mobileLoadAdaptiveImg = () => {
    var mobileImg = $('.lazy-adaptive'),
        mobilepUrl = mobileImg.data('mobileimage'),
        mobileMap = mobileImg.data('mobilemap'),
        mobileSrc = mobileImg.attr('src');
    if (typeof mobileSrc == "undefined" || mobileSrc == "" || mobileSrc == " " || mobileImg.hasClass('desktop-img'))(mobileImg) ? mobileImg.attr('src', mobilepUrl).attr('usemap', mobileMap).addClass('mobile-img').removeClass('desktop-img').show() : $(this).hide();
};

var desktopTabletLoadAdaptiveImg = () => {
    var desktopImg = $('.lazy-adaptive'),
        desktopUrl = desktopImg.data('deskimage'),
        desktopMap = desktopImg.data('deskmap'),
        desktopSrc = desktopImg.attr('src');
    if (typeof desktopSrc == "undefined" || desktopSrc == "" || desktopSrc == " " || desktopImg.hasClass('mobile-img'))(desktopImg) ? desktopImg.attr('src', desktopUrl).attr('usemap', desktopMap).addClass('desktop-img').removeClass('mobile-img').show() : $(this).hide();
};

export {
  desktopTabletLoadAdaptiveImg,
  mobileLoadAdaptiveImg
}
